import { gql, useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'

import {
  QualtricsRootQuery,
  QualtricsScriptLoader_ViewerFragment,
} from './__generated__/qualtrics-script-loader.graphql'
import { LIGHTHOUSE_PID } from './constants'
import { QualtricsScript } from './qualtrics-script'

export interface QualtricsScriptLoaderProps {
  viewer: QualtricsScriptLoader_ViewerFragment | null
  delayMs?: number
  loadPercentage?: number
}

export const QUALTRICS_ROOT = gql`
  query QualtricsRoot {
    root {
      viewer: me {
        ...QualtricsScript_viewer
      }
    }
  }
  ${QualtricsScript.fragments.viewer}
`

export const QualtricsScriptLoader = (props: QualtricsScriptLoaderProps) => {
  const { viewer, delayMs = 10000, loadPercentage = 5 } = props
  const [fetchQualtricsQuery, { data, loading }] = useLazyQuery<QualtricsRootQuery>(QUALTRICS_ROOT)

  useEffect(() => {
    const shouldLoadScript = !!(
      viewer &&
      (viewer.pid % 100 < loadPercentage || viewer.pid === LIGHTHOUSE_PID)
    )
    if (!shouldLoadScript) {
      return
    }

    const timeout = setTimeout(() => {
      fetchQualtricsQuery()
    }, delayMs)

    return () => {
      clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewer?.pid, loadPercentage, fetchQualtricsQuery])

  if (!loading && data) {
    return <QualtricsScript viewer={data.root.viewer} />
  }

  return null
}

QualtricsScriptLoader.fragments = {
  viewer: gql`
    fragment QualtricsScriptLoader_viewer on Profile {
      pid
    }
  `,
}
